import React from 'react'
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, change, reset } from 'redux-form';
import { connectModal } from 'redux-modal';
import { Button, Form, Modal } from 'react-bootstrap';
import * as validators from 'misc/validators';
import { NG_WORD_ADD_MODAL, NG_WORD_ADD_FORM } from 'misc/constants';
import { isNGWordAddModalLoading } from 'selectors/loading';
import Spinner from 'components/core/Spinner';
import CharField from 'components/core/CharField';
import TextField from 'components/core/TextField';
import SelectField from 'components/core/SelectField';
import ClientAsyncSelectField from 'components/core/ClientAsyncSelectField';
import PureRenderComponent from 'components/core/PureRenderComponent';

class NGWordAddModal extends PureRenderComponent {

  hide = () => {
    this.props.handleHide()
    this.props.reset(NG_WORD_ADD_FORM);
  }

  render() {
    const {
      show,
      handleSubmit,
      handleAddNGWord,
      languageOptions,
      isLoading
    } = this.props

    return (
      <Modal
        show={show}
        onHide={this.hide}
        animation={true}
        backdrop="static">
        <Form
          noValidate
          autoComplete="off">
          <Modal.Header closeButton>
            <Modal.Title>Add New NG Word</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Field
              name="word"
              label="Word"
              type="text"
              validate={[
                validators.required,
                validators.maxLength254
              ]}
              isRequired={true}
              component={CharField.Labeled} />
            <Field
              name="language"
              label="Language"
              options={languageOptions}
              isRequired={true}
              validate={[
                validators.required,
              ]}
              component={SelectField.Labeled} />
            <Field
              name="client"
              label="Client"
              isRequired={false}
              component={ClientAsyncSelectField.Labeled} />
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="pull-left"
              bsSize="sm"
              type="button"
              onClick={this.hide}>
              <FontAwesome name="close" className="mr-5" />Close
            </Button>
            <Button
              bsStyle="primary"
              bsSize="sm"
              type="button"
              onClick={handleSubmit(values => handleAddNGWord(values))}>
              <FontAwesome name="paper-plane-o" className="mr-5" />Submit
            </Button>
          </Modal.Footer>
          <Spinner isLoading={isLoading} />
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: false
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    change,
    reset,
  }, dispatch)
}


NGWordAddModal = connectModal({
  name: NG_WORD_ADD_MODAL
})(NGWordAddModal);

NGWordAddModal = reduxForm({
  form: NG_WORD_ADD_FORM
})(NGWordAddModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NGWordAddModal);
